/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SendMailVaccineAliases {
  BUTTON_SEND_MAIL = 'button-send-mail',
  FIELD_LIST_DROPDOWN_SEND_MAIL = 'field-list-dropdown-send-mail',
  FIELD_SEND_MAIL = 'field-send-mail',
  FORM_DROPDOWN_SEND_MAIL = 'form-dropdown-send-mail',
  INPUT_EMAIL_SEND_MAIL_VACCINE = 'input-email-send-mail-vaccine',
  LAYOUT_SEND_MAIL_SEND_MAIL_VACCINE = 'layout-send-mail-send-mail-vaccine',
  LOADER_SEND_MAIL = 'loader-send-mail',
  PANEL_BUTTON_SEND_MAIL_SEND_MAIL_VACCINE = 'panel-button-send-mail-send-mail-vaccine',
  PANEL_LOADER_SEND_MAIL = 'panel-loader-send-mail',
  PANEL_SEND_MAIL_FORMULARY_SEND_MAIL_VACCINE = 'panel-send-mail-formulary-send-mail-vaccine',
  SEND_MAIL_FIELD_EMAIL_LIST = 'send-mail-field-email-list',
  SEND_MAIL_FIELD_NOTES = 'send-mail-field-notes',
  SEND_MAIL_PANEL = 'send-mail-panel',
  SEND_MAIL_VACCINE = 'send-mail-vaccine',
  TEXT_AREA_NOTES_SEND_MAIL_VACCINE = 'text-area-notes-send-mail-vaccine',
}
export { SendMailVaccineAliases };
